module.exports = __webpack_public_path__ + "static/media/anna-img.13b25bc1.jpg";